import * as lucideIcons from 'lucide-vue-next'
import iconPaths from '../../lib/internal-icons'
import type { PascalToKebab } from '@storyblok/vue-utils'

export type LucideIconComponentName = Exclude<
  keyof typeof lucideIcons,
  'Icon' | 'createLucideIcon' | 'icons'
>

export type LucideIconName = PascalToKebab<LucideIconComponentName>

export type InternalIconName = keyof typeof iconPaths

export type IconName = LucideIconName | InternalIconName

export const isLucideIconName = (
  iconName: IconName,
): iconName is LucideIconName => !(iconName in iconPaths)
